import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const BibCollection: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.45 43.45">
            <g>
                <path fill={color} d="M10.98,19.79h-4.89l-1.11.86v1.11h5.98c.81,0,1.22.4,1.22,1.2v1.69c0,.69-.31,1.09-.94,1.22l-4.27.86c-1.62.33-2.42,1.41-2.42,3.26v4.59h9.82v-1.97h-7.63v-2.72c0-.69.31-1.09.94-1.22l4.27-.86c1.61-.33,2.42-1.42,2.42-3.26v-1.37c0-2.26-1.13-3.39-3.39-3.39Z"/>
                <path fill={color} d="M23.29,25.66h-4.24v-3.9h6.99v-1.97h-9.18v7.85h6.41c.81,0,1.22.41,1.22,1.22v2.55c0,.8-.41,1.2-1.22,1.2h-6.62v1.11l1.11.86h5.53c2.26,0,3.39-1.13,3.39-3.39v-2.14c0-2.26-1.13-3.39-3.39-3.39Z"/>
                <polygon fill={color} points="29.16 21.76 36.79 21.76 36.79 23.33 31.09 34.09 31.37 34.58 33.32 34.58 38.98 23.8 38.98 19.79 29.16 19.79 29.16 21.76"/>
                <path fill={color} d="M0,0v40.94l1.86-1.76V13.94h39.72v27.64H2.04l-1.97,1.86h43.38V0H0ZM27.95,12.08H1.86V1.86h26.09v10.21ZM41.58,12.08h-11.77V1.86h11.77v10.21Z"/>
            </g>
        </svg>
    );
};

export default BibCollection;
